import { generateKeys, generateLocalization } from '../utils';
export const notificationAreaPlatformTypes = generateLocalization('notificationAreaPlatformTypes', generateKeys({
    dashboard: {
        label: 'Dashboard',
        value: 'dashboard',
        enabled: true,
        localization: { id: '', defaultMessage: '' },
    },
    website: {
        label: 'Website',
        value: 'website',
        enabled: true,
        localization: { id: '', defaultMessage: '' },
    },
    webtrader: {
        label: 'Webtrader',
        value: 'webtrader',
        enabled: false,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const notificationAreaFileTypes = generateKeys({
    png: {
        value: 'png',
        label: 'png',
        acceptedTypes: 'image/png',
        category: 'image',
        types: ['png'],
        width: 1104,
        height: 280,
    },
});
